import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import NotFound from './components/NotFound';
import CustomCursor from './components/CustomCursor';
import { LenisProvider } from './components/LenisProvider';
import DesktopNotifier from './components/DesktopNotifier';

function App() {
  return (
    <LenisProvider>
      <div className="bg-black text-text-primary min-h-screen font-sans">
        <CustomCursor />
        <DesktopNotifier />

        <Router>
          <Routes>
            {/* Route for the main portfolio page */}
            <Route path="/" element={<Home />} />
            
            {/* Catch-all route for any other path, showing the 404 page */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </div>
    </LenisProvider>  
  );
}

export default App;